import React from 'react';

import { colors } from '../../styles/colors';

type Props = {
  children: React.ReactNode;
  /** Href is the hash URL that skiplink should jump to. Most likely it will be main "#main" */
  href?: string;
  className?: string;
};

/**
 * Skip link allows the user to jump directly to the main content on the page, bypassing the header navigation.
 * It activates automatically on keyboard focus.
 * https://a11yproject.com/posts/skip-nav-links/
 **/
const SkipLink = ({ children, href = '#main', ...props }: Props) => (
  <a
    css={{
      left: '-999px',
      position: 'absolute',
      top: 'auto',
      height: '1px',
      width: '1px',
      overflow: 'hidden',
      outline: 'none',
      '&:focus-visible, &[data-focus-visible-added]': {
        position: 'fixed',
        background: colors.components.fixedTop.Background.Open,
        color: colors.components.fixedTop.Text.Open,
        border: `2px solid ${colors.components.fixedTop.Text.Open}`,
        top: 0,
        left: 0,
        padding: '1rem',
        width: '100%',
        height: 'auto',
        overflow: 'auto',
        textDecoration: 'underline',
        textAlign: 'center',
        zIndex: 10,
      },
    }}
    href={href}
    {...props}
  >
    {children}
  </a>
);

SkipLink.displayName = 'SkipLink';

export default SkipLink;
